import { Component, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { BankingAccountFilters, BankingAccountQueryParams } from '../banking.model';

@Component({
    selector: 'ifb-banking-account-list-filter-dialog',
    templateUrl: './banking-account-list-filter-dialog.component.html',
    standalone: false
})
export class BankingAccountListFilterDialogComponent {
  form: UntypedFormGroup;
  filters: BankingAccountFilters;
  today = new Date();

  constructor(
    public dialogRef: MatDialogRef<BankingAccountListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.filters = new BankingAccountFilters(data.query);
    this.form = this.formBuilder.group({
      onlyPendingAccounts: this.data.query.onlyPendingAccounts === 'true' || false,
    });
  }

  static show(dialog: MatDialog, query: BankingAccountQueryParams): Observable<any> {
    return dialog
      .open(BankingAccountListFilterDialogComponent, {
        data: { query },
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new BankingAccountFilters(formValues));
  }
}
